import { exportVulDetailReport } from '@/api/base';

export async function exportFile(taskId, params, exportFilename) {
  try {
    const response = await exportVulDetailReport(taskId, params);
    const defaultFilename = params.type === 'html' ? `${exportFilename}.zip` : `${exportFilename}.pdf`;
    const contentDisposition = response.headers['Content-Disposition'] || response.headers['content-disposition'];
    const filename = contentDisposition ? getFilenameFromContentDisposition(contentDisposition) || defaultFilename : defaultFilename;

    download(response.data, filename);
  } catch (error) {
    console.error('Error downloading file:', error);
  }
}

function getFilenameFromContentDisposition(contentDisposition) {
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(contentDisposition);
  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }

  return '';
}

export function download(data, filename) {
  try {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Error downloading file:', error);
  }
}
